// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__WHIQw","header":"PatientBlock_header__3U0S4","label":"PatientBlock_label__2co2J","option":"PatientBlock_option__1mH4P"};